<template>
  <DBox
    :id="'cmp-distributio-account-ssetup-manual_matches'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('tracks')}`"
 
  >
    <NTable
      class="dbox1"
      id="distributio-account-ssetup-manual_matches"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td @click="onTrackClick(item)" v-bind="tdcon('text02')">
            <span class="txtov">{{ item["text02"] }}</span>
          </td>
          <td v-bind="tdcon('relation')">
            <span class="txtov">{{ item["relation"] }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteAccountRelation(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedAccountsDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("text02", { text:'text'}),
        createTableHeader("relation", {  }),
        createTableHeader("options", { text: false ,mw:30})
      ];
    },

    list: function() {
      return this.selectedAccountsDetails.relations || [];
    }
  },

  methods: {
    deleteAccountRelation:function(item){
      console.log("ITEM",item);
      this.$emit("delete",item);
    }
  }
};
</script>
